<details #languageMenu class="language-switcher">
  <summary
    class="language-switcher__trigger"
    [attr.aria-label]="i18n.t('language.change')"
  >
    @if (i18n.language() === 'de') {
      <span class="flag flag--de" aria-hidden="true"></span>
    } @else {
      <span class="flag flag--en" aria-hidden="true"></span>
    }
  </summary>

  <div class="language-switcher__menu">
    <button
      type="button"
      [class.language-switcher__option--active]="i18n.language() === 'de'"
      (click)="setLanguage('de')"
    >
      <span class="flag flag--de" aria-hidden="true"></span>
      <span>{{ i18n.t('language.de') }}</span>
    </button>

    <button
      type="button"
      [class.language-switcher__option--active]="i18n.language() === 'en'"
      (click)="setLanguage('en')"
    >
      <span class="flag flag--en" aria-hidden="true"></span>
      <span>{{ i18n.t('language.en') }}</span>
    </button>
  </div>
</details>
